import httpApiApplication from 'app/http/httpApiApplication';

const baseCatalogUrl = 'catalog-values';
class TranslateService {
  langList(): Promise<Array<string>> {
    return httpApiApplication.get(baseCatalogUrl + '/langs');
  }
}
export default new TranslateService();
